import { firstValueFrom } from 'rxjs';
import {
  DischargeInfo,
  DischargeInfoDto,
  RequestDto,
} from '../models/request.dto';
import { AuthService } from '../services/auth.service';
import { RequestService } from '../services/request.service';
import { FormDto } from '../models/form.dto';
import { AttachmentService } from '../services/attachment.service';

export async function handleSchedaAnamnesticaNonOspPreSave(
  api: any,
  request: RequestDto,
  requestDates: DischargeInfo[],
  services: { requestService: RequestService; authService: AuthService; attachmentService: AttachmentService },
  form: FormDto,
  compositionId: string,
) {
  const attachmentCode = api?.getFieldModel(
    'scheda_anamnestica_per_l_accesso_al_sistema_delle_cure_intermedie_riabilitative_e_residenziali_non_ospedaliere/context/paziente/l104_string'
  )?.value[0]?.label;

  const fileName = api?.getFieldModel(
    'scheda_anamnestica_per_l_accesso_al_sistema_delle_cure_intermedie_riabilitative_e_residenziali_non_ospedaliere/context/paziente/nome_allegato'
  )?.value[0];

  const fileContentType = api?.getFieldModel(
    'scheda_anamnestica_per_l_accesso_al_sistema_delle_cure_intermedie_riabilitative_e_residenziali_non_ospedaliere/context/paziente/estensione_allegato'
  )?.value[0];

  const fileuuid = api?.getFieldModel(
    'scheda_anamnestica_per_l_accesso_al_sistema_delle_cure_intermedie_riabilitative_e_residenziali_non_ospedaliere/context/paziente/uuid'
  )?.value[0];

  let requestAttachment = {
    transitionUuid: request.uuid,
    attachmentCode: attachmentCode,
    formId: form.id,
    compositionId: form.compositionId ? form.compositionId : compositionId,
    fileName: fileName,
    fileContentType: fileContentType,
    fileUuid: fileuuid
  }

  await firstValueFrom(
        services.attachmentService.insertAttachmentFromForm(requestAttachment)
      );
  
}
